export default function (props: any) {
    return (
        <svg width="39px" height="38px" viewBox="0 0 39 38" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="DELTA-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="TV_icon" transform="translate(0.983755, 0.000000)">
                    <rect id="矩形" x="0" y="0" width="38" height="38"></rect>
                    <g id="编组-66" transform="translate(1.975757, 5.981462)" stroke="#FFFFFF" strokeWidth="1.30955712">
                        <polyline
                            id="路径"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            points="21.6295404 25.0356507 21.6295404 22.0313727 12.6167061 22.0313727 12.6167061 25.0356507"
                        ></polyline>
                        <path
                            d="M1.79213339,0 L32.2563516,0 C33.2461749,0 34.048485,0.821983885 34.048485,1.83607895 L34.048485,20.4566909 C34.048485,21.3264401 33.3604247,22.0313727 32.5114924,22.0313727 L1.79213339,22.0313727 C0.802310144,22.0313727 0,21.2093888 0,20.1952937 L0,1.83607895 C0,0.821983885 0.802310144,0 1.79213339,0 Z"
                            id="Stroke-301"
                        ></path>
                        <line
                            x1="7.81558509"
                            y1="25.5363638"
                            x2="25.8412536"
                            y2="25.5363638"
                            id="Stroke-302"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}
